import React from 'react';
import PropTypes from 'prop-types';
import { Sticky } from 'react-sticky';
import classNames from 'classnames';
import Style from './AltHeader.module.scss';

const AltHeader = ({
  background = null,
  bottomOffset = null,
  children = null,
  className = null,
  isAltHeader = false,
  isNavScheduleRendered = false,
  onTitleClick = null,
  persist = false,
  renderAltHeader = false,
  stickyHeaderCallback = null,
  theme,
  title = null,
  titleClassName = null,
  topOffset = null,
}) => {
  if (!renderAltHeader) return null;
  const titleClasses = [theme.altHeadline, Style.altHeadline, titleClassName];
  if (onTitleClick) titleClasses.push(Style.pointer);
  const headerWithNav = isNavScheduleRendered
    ? classNames(theme.stickyHeaderWithNavSchedule, Style.stickyHeaderWithNavSchedule)
    : null;
  const stickyClasses = classNames([
    className,
    !isAltHeader && !persist
      ? classNames(theme.hide, Style.hide)
      : classNames(theme.stickyHeader, Style.stickyHeader),
    headerWithNav,
  ]);
  const fallbackBackground = background
    ? null
    : classNames(theme.fallbackBackground, Style.fallbackBackground);
  const titleComponent = title && (
    <a
      href=""
      className={classNames(titleClasses)}
      onClick={onTitleClick}
      data-testid="altheader-title"
    >
      {title}
    </a>
  );

  return (
    <Sticky
      className={stickyClasses}
      topOffset={topOffset}
      bottomOffset={bottomOffset}
      onStickyStateChange={stickyHeaderCallback}
      style={{ backfaceVisibility: 'hidden', transform: 'translateZ(null)' }}
      data-testid="altheader"
    >
      <div
        className={classNames([
          'hideOverflow',
          theme.altHeaderContainer,
          Style.altHeaderContainer,
          fallbackBackground,
        ])}
      >
        {background}
        <div className={classNames(theme.altHeader, Style.altHeader)}>
          {titleComponent}
          {children}
        </div>
      </div>
    </Sticky>
  );
};

AltHeader.defaultProps = {
  background: null,
  bottomOffset: 0,
  children: null,
  className: null,
  isAltHeader: false,
  isNavScheduleRendered: null,
  onTitleClick: null,
  persist: false,
  renderAltHeader: true,
  stickyHeaderCallback: () => {},
  theme: {},
  title: null,
  titleClassName: null,
  topOffset: 80,
};

AltHeader.propTypes = {
  background: PropTypes.shape({}),
  bottomOffset: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
  isAltHeader: PropTypes.bool,
  isNavScheduleRendered: PropTypes.bool,
  onTitleClick: PropTypes.func,
  persist: PropTypes.bool,
  renderAltHeader: PropTypes.bool,
  stickyHeaderCallback: PropTypes.func,
  theme: PropTypes.shape({}),
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  topOffset: PropTypes.number,
};

export default AltHeader;
